import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"


import LanguageDropdown from "../../LanguageDropdown";
import { checkPermission, chequeDates, clearTemporaryStorage, formatDate, formatMoney, formatMoneyInput, getCurrentChequeDate, regexPhoneNumber } from 'helpers/helpers'
import { DELETE, GET, httpOk, POST, PUT } from "helpers/api";
import Directory from "../Directory";

import XReport from "components/XReport";
import Clients from "pages/main/reports/ClientDebt";
import ClientsHistory from "pages/main/reports/ClientDebtInner";

import { SET_SETTINGS } from "store/settings/actions";
import CustomTooltip from "pages/parts/CustomTooltip";
import FilterPagination from "pages/parts/FilterPagination";
import DeleteModal from "pages/parts/DeleteModal";
import useDidMountEffect from "pages/parts/useDidMountEffect";

function Header() {
	const { t } = useTranslation()
	const location = useLocation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	const reduxAccount = useSelector(state => state.account)
	const reduxCashbox = useSelector(state => state.cashbox)

	const counterparties = [
		{ 'id': "clients", 'name': t('customer_debt') },
	]

	const transactionTypes = [
		{ 'id': "minus", 'name': t('expense') },
		{ 'id': "plus", 'name': t('income') },
	]

	const [modalLogout, setModalLogout] = useState(false)
	const [modalConfirm, setModalConfirm] = useState(false)
	const [leftInRegister, setLeftInRegister] = useState('') // smena yopishda kassaga qoldiriladigan razmen
	const [counted, setCounted] = useState(false) // "pulni sanadim" tasdig'i — Тасдиқлайман faollashishi uchun
	const [openRollModalConfirm, setOpenRollModalConfirm] = useState(false)
	const [modalDirectory, setModalDirectory] = useState(false)
	const [showUserDropdown, setShowUserDropdown] = useState(false)
	const [modalDebtors, setModalDebtors] = useState(false);
	const [modalExpenseCreate, setModalExpenseCreate] = useState(false);
	const [pendingDebt, setPendingDebt] = useState({ count: 0, overdue: 0 });
	const [modalClients, setModalClients] = useState(false);
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [modalRolls, setModalRolls] = useState(false)
	const [modalDelete, setModalDelete] = useState({ show: false })
	const [search, setSearch] = useState("")

	const [selectedItem, setSelectedItem] = useState({ 'transaction_type': 'minus' })
	const [selectedClient, setSelectedClient] = useState({})
	const [selectedCategory, setSelectedCategory] = useState({
		children: [],
	})
	const [categories, setCategories] = useState([])
	const [accounts, setAccounts] = useState([])

	const [currentCurrency, setCurrentCurrency] = useState(0)

	const [modalExpense, setModalExpense] = useState({ show: false, amount: '', note: '', type: 'table' });
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		// status: 10,
		random: 0,
		search: '',
	})
	const [expenseFilterData, setExpenseFilterData] = useState({
		search: '',
		cashier_login: '',
		transaction_type: '',
		payment_type_id: '',
		payment_purpose_id: '',
	})

	// const [accounts, setAccounts] = useState([])
	const [expenseData, setExpenseData] = useState({ data: [] })
	const [expenses, setExpenses] = useState([])
	const [clients, setClients] = useState([])
	const [employees, setEmployees] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [debtors, setDebtors] = useState([])

	const [xReport, setXReport] = useState({
		show: false,
		products: {},
		payment_types: [],
		opened_shift: {},
	})

	function handleChangePayment(index, e) {
		var xReportCopy = { ...xReport }
		var paymentsCopy = xReportCopy.payment_types
		if (paymentsCopy[index]?.is_usd) {
			paymentsCopy[index]['fact_amount_usd'] = e.target.value.replace(/[^\d.]/g, '');
			paymentsCopy[index]['fact_amount'] = paymentsCopy[index]['fact_amount_usd'] * currentCurrency;
		} else {
			paymentsCopy[index]['fact_amount'] = e.target.value.replace(/[^0-9.]/g, '');
		}
		xReportCopy.total_fact_amount = 0;
		for (let i = 0; i < paymentsCopy.length; i++) {
			xReportCopy.total_fact_amount += Number(paymentsCopy[i]['fact_amount'])
		}
		setXReport({ ...xReportCopy })
	}

	// Farq sababi (fact_note) — farq bo'lganda majburiy
	function handleChangeNote(index, value) {
		var xReportCopy = { ...xReport }
		xReportCopy.payment_types[index]['fact_note'] = value
		setXReport({ ...xReportCopy })
	}

	// Smena yopish tugmasi faol bo'lishi sharti: har farqli turда sabab + "pulni sanadim"
	function canCloseShift() {
		const types = xReport?.payment_types || []
		for (let i = 0; i < types.length; i++) {
			const diff = Math.round(Number(types[i].fact_amount) - Number(types[i].expected_amount || 0))
			if (Math.abs(diff) >= 1 && !String(types[i].fact_note || '').trim()) return false
		}
		return counted
	}

	async function openShift() {
		const response = await POST('/shift-open')
		if (httpOk(response)) {
			console.log(response.data);
			dispatch({ 'type': 'CHANGE_ACCOUNT', payload: { ...reduxAccount, shift: response.data } })
		}
	}

	async function closeShift() {
		const response = await POST('/shift-close', {
			...xReport,
			id: reduxAccount.shift.id,
			left_in_register: Number(leftInRegister) || 0, // kassaga qoldiriladigan razmen
		})
		if (httpOk(response)) {
			dispatch({ 'type': 'CHANGE_ACCOUNT', payload: { ...reduxAccount, shift: {} } })
			setModalConfirm(false)
			setLeftInRegister('')
		}
	}

	async function logout() {
		dispatch({ 'type': 'USER_LOGGED_OUT', payload: null })
		clearTemporaryStorage()
		navigate('/auth/login')
	}

	function redirect() {
		if (!location.pathname.includes('/cashbox/')) {
			navigate('/documents-in');
			return;
		}
		navigate(-1);
	}

	async function createExpense(e) {
		e.preventDefault();
		var sendData = { ...modalExpense }
		sendData.shift_id = reduxAccount.shift.id;
		sendData.amount = Number(sendData.amount);
		const response = await POST('/expense', sendData)
		if (httpOk(response)) {
			setModalExpense({ show: false });
			getExpenseData();
			getClients();
		}
	}

	async function toggleModalDelete(bool, index) {
		var item = { ...expenseData.data[index] }
		setModalDelete({ show: bool, index, item, note: bool ? '' : modalDelete.note })
		setModalExpense({ ...modalExpense, show: !bool })
	}

	async function deleteExpense() {
		const response = await DELETE(`/expense/${modalDelete.item.id}`, { deleted_note: modalDelete.note }, { loader: true })
		if (httpOk(response)) {
			toggleModalDelete(false)
			getExpenseData()
		}
	}

	async function selectExpense(option) {
		if (option?.counterparty === 'clients') {
			if (!clients.length) await getClients();
		}
		if (option?.counterparty === 'employee') {
			if (!employees.length) await getEmployees();
		}
		setModalExpense({
			...modalExpense,
			payment_purpose_id: option?.id,
			transaction_type: option?.transaction_type,
			counterparty: option?.counterparty,
			entity_type: option?.counterparty,
		})
	}

	async function getXReport(shift_id) {
		const response = await POST('/x-report', { shift_id: shift_id }, { loader: true })
		if (httpOk(response)) {
			setXReport({ ...response.data, show: true, shift_id: shift_id })
		}
	}

	async function toggleModalDebtors(bool) {
		if (bool) {
			await getDebtors()
			if (!clients.length) await getClients()
			if (!cashiers.length) await getCashiers()
		}

		setModalDebtors(bool)
	}

	async function toggleModalClients(bool) {
		if (!bool && selectedClient.client_id) {
			setSelectedClient({})
			return;
		}
		setModalClients(bool)
	}

	async function createUpdateExpense(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/payment-purposes', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-purposes', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			getExpenses()
			toggleModalExpenseCreate(false)
			setSelectedItem({})
		}
	}

	async function getAccounts() {
		const response = await GET('/helper/accounts')
		if (httpOk(response)) setAccounts(response.data)
	}

	async function toggleModalExpenseCreate(bool) {
		if (bool) {
			if (accounts.length === 0) await getAccounts()
		}

		setModalExpenseCreate(bool)
		toggleModalExpense(!bool)
	}

	async function openRoll(item) {
		const response = await PUT('/products/open-roll', {
			balance_id: item.balance_id
		}, { loader: true })
		if (httpOk(response)) {
			getCategories()
			toggleOpenRollModalConfirm(false)
			// setModalRolls(false)
		}
	}

	function toggleOpenRollModalConfirm(bool, item = {}) {
		setOpenRollModalConfirm({ ...openRollModalConfirm, show: bool, item: item })
		setModalRolls(!bool)
	}

	async function toggleModalConfirm(bool) {
		if (bool) {
			const response = await POST('/x-report/payments', { shift_id: reduxAccount.shift?.id }, { loader: true })
			if (httpOk(response)) {
				for (let i = 0; i < response.data.payment_types.length; i++) {
					if (response.data.payment_types[i]['is_usd']) {
						response.data.payment_types[i]['income_amount_usd'] = Math.round(response.data.payment_types[i]['income_amount'] / currentCurrency)
						// USD fakt = to'liq fakt (som) / kurs — Kutilgan bilan bir xil birlik (fantom farq bo'lmaydi)
							response.data.payment_types[i]['fact_amount_usd'] = Math.round(response.data.payment_types[i]['fact_amount'] / currentCurrency)
					}
					response.data.payment_types[i]['fact_amount'] = Math.round(response.data.payment_types[i]['fact_amount'])
					// Kutilgan (expected) = boshlang'ich fact; farq shundan hisoblanadi. fact_note — farq sababi.
					response.data.payment_types[i]['expected_amount'] = Math.round(response.data.payment_types[i]['fact_amount'])
					response.data.payment_types[i]['fact_note'] = ''
				}
				setXReport({ ...xReport, ...response.data })
			}
			setLeftInRegister('') // har ochilishda razmen tozalanadi
			setCounted(false)     // "pulni sanadim" tasdig'i har ochilishda tozalanadi
		}

		setModalConfirm(bool)
	}

	async function getExpenseData(paymentPurposeId) {
		var expenseFilterDataCopy = { ...expenseFilterData }
		if (paymentPurposeId) {
			expenseFilterDataCopy.payment_purpose_id = paymentPurposeId;
			setExpenseFilterData(expenseFilterDataCopy)
		}
		const response = await GET('/shift-expenses', { ...expenseFilterDataCopy, shift_id: reduxAccount.shift?.id, })
		if (httpOk(response)) {
			setExpenseData(response.data)
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setExpenseFilterData({ ...expenseFilterData, 'page': page, 'size': size })
	}

	async function toggleModalExpense(bool, type = 'table', paymentPurposeId) {
		if (bool) {
			if (!expenses.length) getExpenses()
			if (!accounts.length) getAccounts()
			if (!cashiers.length) getCashiers()
			if (type === 'table') {
				if (!expenseData.data.length) await getExpenseData(paymentPurposeId)
			}

			setModalExpense({ ...modalExpense, 'show': true, type, })
			if (xReport.show) setXReport({ ...xReport, 'show': false })
		} else {
			setModalExpense({
				'show': false,
			})
		}
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result })
	}

	async function getDebtors() {
		var filterDataCopy = { ...filterData }
		if (filterDataCopy?.cashiers?.length) {
			filterDataCopy.cashiers_logins = filterDataCopy?.cashiers?.map(c => c.login)?.join(',');
		}
		delete filterDataCopy.cashiers
		const response = await GET('/helper/debtors', filterDataCopy, { loader: true })
		if (httpOk(response)) setDebtors(response.data)
		if (dropdownIsOpen) setDropdownIsOpen(false)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers', {}, { loader: true })
		if (httpOk(response)) setCashiers(response.data)
	}

	async function getClients() {
		const response = await GET('/helper/clients', {}, { loader: true })
		if (httpOk(response)) setClients(response.data)
	}

	async function getEmployees() {
		const response = await GET('/helper/employees-list', {}, { loader: true })
		if (httpOk(response)) setEmployees(response.data)
	}

	async function getExpenses() {
		// const response = await GET('/helper/payment-purposes', {}, { loader: true })
		const response = await GET('/payment-purposes?status=1', {}, { loader: true })
		if (httpOk(response)) setExpenses(response.data)
	}

	async function getOpennedShift() {
		const response = await GET('/shift-openned')
		if (httpOk(response)) {
			dispatch({ 'type': 'CHANGE_ACCOUNT', payload: { ...reduxAccount, shift: response.data } })
		}
	}

	async function getCurrentCurrency() {
		const response = await GET('/current-currency')
		if (httpOk(response)) {
			setCurrentCurrency(response.data)
			dispatch(SET_SETTINGS({ currency: response.data }))
		}
	}

	async function getCategories() {
		const response = await GET('/helper/categories-children')
		if (httpOk(response)) {
			setCategories(response.data)
			if (selectedCategory.id) {
				var index = response.data.findIndex(item => item.id === selectedCategory.id)
				if (index >= 0) {
					setSelectedCategory(response.data[index])
				} else {
					setSelectedCategory(response.data[0])
				}
			} else {
				setSelectedCategory(response.data[0])
			}
		}
	}

	useEffect(() => {
		getOpennedShift()
		getCurrentCurrency()
		getCategories()
		getPendingDebtCount()
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	async function getPendingDebtCount() {
		const res = await GET('/pending-orders/count', {}, { loader: false })
		if (httpOk(res)) setPendingDebt(res.data)
	}

	useDidMountEffect(() => {
		getExpenseData()
	}, [expenseFilterData.page, expenseFilterData.size]); // eslint-disable-line react-hooks/exhaustive-deps


	function getCategoriesList() {
		var arr = [...categories]
		if (search) {
			arr = arr.filter(item =>
				item.name.toLowerCase().includes(search.toLowerCase())
			);
		}

		return arr;
	}


	function useOutsideAlerter(ref) {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowUserDropdown(false)
				}
			}
			document.addEventListener("mousedown", handleClickOutside);
			return () => {
				document.removeEventListener("mousedown", handleClickOutside);
			};
		}, [ref]);
	}

	function getDifference(date) {
		if (date) {
			const today = new Date();
			const inputDate = new Date(date);
			today.setHours(0, 0, 0, 0);
			inputDate.setHours(0, 0, 0, 0);
			const differenceMs = inputDate.getTime() - today.getTime();
			const differenceDays = differenceMs / (1000 * 60 * 60 * 24);

			return Math.round(differenceDays);
		}

		return '';
	}

	return (
		<>
			<header className="d-between" id="page-topbar" style={{ left: 0 }}>
				<div className="cursor" onClick={() => redirect()}>
					<i className="uil-angle-left-b fz-32 text-black cursor ps-2"></i>
				</div>

				<div className="d-flex align-items-center justify-content-end gap-2">
					<Link to="/currency" className="alert mb-0" role="alert" style={{ height: '40px' }}>
						{t('rate')} = {formatMoney(currentCurrency)}
					</Link>

					<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => setModalDirectory(true)}>
						{t('directory')}
					</button>

					<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => toggleModalDebtors(true)}>
						{t('debtors')}
					</button>

					<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => toggleModalClients(true)}>
						{t('clients')}
					</button>

					<button
						className={`btn ${pendingDebt.overdue > 0 ? 'btn-danger' : (pendingDebt.count > 0 ? 'btn-warning' : 'btn-primary')} position-relative`}
						style={{ height: '40px' }}
						onClick={() => navigate('/cashbox/pending-orders')}>
						{t('roll_debt')}
						{pendingDebt.count > 0 &&
							<span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-dark">
								{pendingDebt.count}{pendingDebt.overdue > 0 ? ' ⚠' : ''}
							</span>
						}
					</button>

					{checkPermission('cashbox.expense_income') &&
						<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => toggleModalExpense(true)}>
							{t('income_expense')}
						</button>
					}

					{reduxAccount.role === 'ROLE_OWNER' &&
						<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => setModalRolls(true)}>
							{t('open_roll')}
						</button>
					}

					{reduxAccount.shift?.id ?
						<>
							{checkPermission('cashbox.x_report') &&
								<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => getXReport(reduxAccount.shift?.id)}>
									X {t('report')}
								</button>
							}

							{checkPermission('cashbox_close_shift') &&
								<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => toggleModalConfirm(true)}>
									{t('close_shift')}
								</button>
							}
						</>
						:
						<>
							{checkPermission('cashbox.open_shift') &&
								<button className="btn btn-primary" style={{ height: '40px' }} onClick={() => openShift()}>
									{t('open_shift')}
								</button>
							}
						</>
					}

					<LanguageDropdown />

					<div className="d-lg-inline-block dropdown" >
						<button type="button" className="btn header-item noti-icon waves-effect" ref={wrapperRef}>
							<div className={`profile-dropdown`}>
								<div className={`profile-dropdown-toggle`}
									onClick={() => setShowUserDropdown(!showUserDropdown)}>
									<i className="uil uil-user" color="#fff"></i>
								</div>
								{showUserDropdown &&
									<div className="profile-dropdown-menu">
										<div className="profile-dropdown-item">
											<div>{t('name')}:</div>
											<div>{reduxAccount.name}</div>
										</div>
										<div className="profile-dropdown-item">
											<div>{t('login')}:</div>
											<div>{reduxAccount.login}</div>
										</div>
										<div className="profile-dropdown-item">
											<div>ID:</div>
											<div>{reduxAccount.id}</div>
										</div>
										<div className="profile-dropdown-item second d-none"
											onClick={() => {
												navigate('/payment')
												setShowUserDropdown(false)
											}}>
											{t('payment')}
											<i className="uil-transaction"></i>
										</div>
										<div className="profile-dropdown-item second"
											onClick={() => setModalLogout(true)}>
											<div>
												{t('logout')}
											</div>
											<i className="uil-signin"></i>
										</div>
									</div>
								}
							</div>
						</button>
					</div>
				</div>
			</header>

			<Modal show={modalLogout} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalLogout(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('logout')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_logout')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalLogout(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => logout()}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>

			<Modal show={modalConfirm} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('close_shift')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>{t('name')}</th>
								<th className="text-end">{t('expected_amount')}</th>
								<th className="text-end">{t('fact')}</th>
								<th className="text-end">{t('difference')}</th>
								<th>{t('reason')}</th>
							</tr>
						</thead>
						<tbody>
							{xReport?.payment_types.map((item, index) => {
								const expected = Number(item.expected_amount || 0)
								const diff = Math.round(Number(item.fact_amount || 0) - expected)
								const diffColor = diff === 0 ? '#12a150' : (diff < 0 ? '#dc3545' : '#e8850c')
								const needReason = Math.abs(diff) >= 1
								const reasonEmpty = needReason && !String(item.fact_note || '').trim()
								return (
									<tr key={index}>
										<td className="fw-500">{item.name}</td>
										<td className="text-end">{formatMoney(expected)}</td>
										<td className="td-input" style={{ minWidth: '105px' }}>
											<input type="text" className="form-control" value={formatMoneyInput(item.is_usd ? item.fact_amount_usd : item.fact_amount)}
												placeholder={item.total_amount} onChange={(e) => handleChangePayment(index, e)} />
										</td>
										<td className="text-end fw-600" style={{ color: diffColor, whiteSpace: 'nowrap' }}>
											{diff === 0 ? '0' : (diff > 0 ? '+' : '') + formatMoney(diff)}
										</td>
										<td style={{ minWidth: '155px' }}>
											{needReason
												? <input type="text" className="form-control" list="shift-reasons" maxLength={500}
													style={reasonEmpty ? { borderColor: '#dc3545' } : {}}
													value={item.fact_note || ''} placeholder={t('reason') + '...'}
													onChange={(e) => handleChangeNote(index, e.target.value)} />
												: <span className="text-muted">—</span>}
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
					<datalist id="shift-reasons">
						<option value={t('reason_wrong_change')} />
						<option value={t('reason_client_short')} />
						<option value={t('reason_count_error')} />
						<option value={t('reason_unrecorded')} />
					</datalist>

					{/* Katta farq ogohlantirish */}
					{(() => {
						const big = (xReport?.payment_types || []).filter(p => Math.abs(Math.round(Number(p.fact_amount) - Number(p.expected_amount || 0))) > 50000)
						if (!big.length) return null
						return (
							<div className="alert alert-danger py-2 px-3 mb-2" style={{ fontSize: '13px' }}>
								<i className="uil-exclamation-triangle me-1"></i>
								{t('big_diff_warning')}: {big.map(p => {
									const d = Math.round(Number(p.fact_amount) - Number(p.expected_amount || 0))
									return `${p.name} ${d > 0 ? '+' : ''}${formatMoney(d)}`
								}).join(', ')}
							</div>
						)
					})()}

					{/* Naqd boshqaruvi: razmen + kutilgan matematikasi */}
					{(() => {
						const cashFact = (xReport?.payment_types || [])
							.filter(p => Number(p.payment_type_category_id) === 1 && !p.is_usd)
							.reduce((s, p) => s + Number(p.fact_amount || 0), 0)
						const opening = Number(xReport.opening_balance || 0)
						let razmen = Number(leftInRegister) || 0
						if (razmen > (opening + cashFact)) razmen = (opening + cashFact)
						const toSafe = Math.max((opening + cashFact) - razmen, 0)
						return (
							<div className="border rounded p-3 mb-2" style={{ background: '#f7f7fb' }}>
								<div className="d-between"><span className="text-muted">{t('opening_razmen')}</span><span>{formatMoney(opening)}</span></div>
								<div className="d-between"><span className="text-muted">{t('cash_this_shift')}</span><span>{formatMoney(cashFact)}</span></div>
								<div className="d-between fw-600 pt-1 mt-1" style={{ borderTop: '1px dashed #cfcfe0' }}><span>{t('total_in_cashbox')}</span><span>{formatMoney(opening + cashFact)}</span></div>
								<div className="form-group mt-2 mb-2">
									<label>{t('leave_in_register')} <span className="text-muted fz-12">({t('cash')})</span></label>
									<input type="text" className="form-control" value={formatMoneyInput(leftInRegister)}
										onChange={(e) => setLeftInRegister(e.target.value.replace(/[^0-9.]/g, ''))} />
								</div>
								<div className="d-between fw-500">{t('transfer_to_safe')}<span className="text-success">{formatMoney(toSafe)}</span></div>
							</div>
						)
					})()}

					{/* Smena yakuni (kontekst) */}
					{xReport.summary &&
						<div className="d-flex flex-wrap gap-2 mb-2" style={{ fontSize: '12.5px' }}>
							<span className="badge bg-light text-dark border">{t('cheques')}: {xReport.summary.cheques}</span>
							<span className="badge bg-light text-dark border">{t('sales')}: {formatMoney(xReport.summary.sales)}</span>
							<span className="badge bg-light text-dark border">{t('debt')}: {formatMoney(xReport.summary.debt)}</span>
							<span className="badge bg-light text-dark border">{t('deleted_cheques')}: {xReport.summary.deleted}</span>
						</div>
					}

					{/* Pulni sanadim tasdig'i */}
					<label className="d-flex align-items-center gap-2 p-2 rounded" style={{ background: '#f4f2ff', cursor: 'pointer' }}>
						<input type="checkbox" checked={counted} onChange={(e) => setCounted(e.target.checked)} style={{ width: '18px', height: '18px' }} />
						<span className="fw-500">{t('counted_confirm')}</span>
					</label>

				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => setModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100" disabled={!canCloseShift()}
							onClick={() => closeShift()}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>

			{/* EXPENSE MODAL PAYMENT */}
			<Modal show={modalExpense.show} animation={false} centered size={modalExpense.type === 'table' ? "xl" : "md"}
				dialogClassName="expense-modal" onHide={() => toggleModalExpense(false)}>
				{modalExpense.type === 'table' ?
					<>
						<Modal.Header closeButton className="gap-2">
							<div className="d-between gap-2 w-100">
								<div className="d-center gap-2">
									<Modal.Title>
										{t('income_expense')} [{expenseData.total}]
									</Modal.Title>
									<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
										<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
											{t('filter')}
										</Dropdown.Toggle>

										<Dropdown.Menu className="dropdown-filter">
											<div className="row">
												<div className="form-group col-md-6">
													<label>{t('cashier')}</label>
													<Select
														options={cashiers}
														value={cashiers.find(option => option.login === expenseFilterData?.cashier_login) || ''}
														onChange={(option) => setExpenseFilterData({ ...expenseFilterData, cashier_login: option?.login })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.login}
														isClearable
													/>
												</div>
												<div className="form-group col-md-6">
													<label>{t('type')}</label>
													<Select
														options={expenses}
														value={expenses.find(option => option.id === expenseFilterData?.payment_purpose_id) || ''}
														onChange={(option) => setExpenseFilterData({ ...expenseFilterData, payment_purpose_id: option?.id })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
														isClearable
													/>
												</div>
												<div className="form-group col-md-6">
													<label>{t('payment_type')}</label>
													<Select
														options={reduxCashbox.paymentTypes}
														value={reduxCashbox.paymentTypes.find(option => option.id === expenseFilterData?.payment_type_id) || ''}
														onChange={(option) => setExpenseFilterData({ ...expenseFilterData, payment_type_id: option?.id })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
														isClearable
													/>
												</div>
												<div className="form-group col-md-6">
													<label>{t('transaction_type')}</label>
													<Select
														options={transactionTypes}
														value={transactionTypes.find(option => option.id === expenseFilterData?.transaction_type) || ''}
														onChange={(option) => setExpenseFilterData({ ...expenseFilterData, transaction_type: option?.id })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
														isClearable
													/>
												</div>
											</div>

											<div className="row mt-3">
												<div className="col-md-12">
													<div className="d-flex justify-content-end gap-2">
														<button className="btn btn-secondary"
															onClick={() => setDropdownIsOpen(false)}>
															{t('cancel')}
														</button>
														<button className="btn btn-primary"
															onClick={() => getExpenseData()}>
															{t('apply')}
														</button>
													</div>
												</div>
											</div>
										</Dropdown.Menu>
									</Dropdown>
								</div>
								<button className="btn btn-primary" onClick={() => toggleModalExpense(true, 'form')}>
									{t('create')}
								</button>
							</div>
						</Modal.Header>
						<Modal.Body>
							<table className="table table-bordered mb-0">
								<thead>
									<tr>
										<th style={{ minWidth: '33px' }}>{t('#')}</th>
										<th style={{ width: '15%' }} className="td-ellipsis">{t('cashier')}</th>
										<th style={{ width: '20%' }} className="td-ellipsis">{t('income_expense')}</th>
										<th style={{ width: '10%' }} className="td-ellipsis">{t('payment_types')}</th>
										<th style={{ width: '10%' }} className="td-ellipsis">{t('counterparty')}</th>
										<th style={{ width: '10%' }} className="td-ellipsis">{t('client')}</th>
										<th style={{ width: '15%' }} className="td-ellipsis">{t('note')}</th>
										<th style={{ width: '10%' }} className="text-end">{t('amount')}</th>
										<th style={{ minWidth: '145px' }} className="text-center">{t('date')}</th>
										<th style={{ minWidth: '40px' }} className="text-center"></th>
									</tr>
								</thead>
								<tbody>
									{expenseData?.data?.map((item, index) => (
										<tr key={index} className={item.entity_type === 'cheques_return' ? 'table-warning' : ''}>
											<td>{item.row_number}</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.created_by}>{item.created_by}</CustomTooltip>
											</td>
											<td className="td-ellipsis">
												{item.entity_type === 'cheques_return'
													? <span className="badge bg-warning text-dark">
														{t('return')} #{item.return_cheque_id}
													</span>
													: item.payment_purpose_name
												}
											</td>
											<td className="td-ellipsis">
												{item.payment_type_name}
											</td>
											<td className="td-ellipsis">
												{t(item.counterparty)}
											</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.client_name}>
													{item.client_name}
												</CustomTooltip>
											</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.note}>{item.note}</CustomTooltip>
											</td>
											<td className={`text-end ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>
												{formatMoney(item.amount)}
											</td>
											<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
											<td>
												<div className="d-center">
													{item.entity_type !== 'cheques_return' &&
														<div className="table-action-button table-action-danger-button" onClick={() => toggleModalDelete(true, index)}>
															<i className="uil-times"></i>
														</div>
													}
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>

							{expenseData.total > 0 &&
								<FilterPagination
									pagination={expenseData}
									paginate={paginate}>
								</FilterPagination>
							}

						</Modal.Body>
					</>
					:
					<>
						<Modal.Body>
							<form>
								<h4 className="text-center">{t('income_expense')}</h4>
								<div>
									<div className="mb-2">
										<label>{t('type')}</label>
										<div className="position-relative">
											<Select
												options={expenses}
												value={expenses.find(option => option.id === modalExpense.payment_purpose_id)}
												onChange={(option) => selectExpense(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => `${option.name} [${option.transaction_type === 'minus' ? t('expense') : t('income')}]`}
												getOptionValue={(option) => option.id}
											/>
											<i className="uil-plus custom-select-btn" onClick={() => toggleModalExpenseCreate(true)} />
										</div>
									</div>
									{modalExpense.counterparty === 'clients' &&
										<>
											<div className="mb-2">
												<label>{t('clients')}</label>
												<Select
													options={clients}
													value={clients.find(option => option.id === modalExpense.counterparty_id)}
													onChange={(option) => setModalExpense({ ...modalExpense, 'counterparty_id': option.id, 'entity_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => `${option.name} - [ ${formatMoney(option.balance)} ]`}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</>
									}
									{modalExpense.counterparty === 'employee' &&
										<div className="mb-2">
											<label>{t('employees')}</label>
											<Select
												options={employees}
												value={employees.find(option => option.id === modalExpense.counterparty_id) || null}
												onChange={(option) => setModalExpense({ ...modalExpense, 'counterparty_id': option.id, 'entity_id': option.id })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									}
									<div className="mb-2">
										<label>{t('payment_types')}</label>
										<Select
											options={reduxCashbox.paymentTypes.filter(item => item.payment_type_category_id === 1 || item.payment_type_category_id === 2)}
											value={reduxCashbox.paymentTypes.find(option => option.id === modalExpense.payment_type_id)}
											onChange={(option) => setModalExpense({ ...modalExpense, 'payment_type_id': option.id, 'payment_type_category_id': option.payment_type_category_id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => `${option.name}`}
											getOptionValue={(option) => option.id}
										/>
									</div>

									<div className="mb-3">
										<label>{t('amount')}</label>
										<input className="form-control" value={formatMoneyInput(modalExpense.amount)}
											onChange={(e) => setModalExpense({ ...modalExpense, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
									</div>
									<div className="mb-2">
										<label>{t('note')}</label>
										<textarea className="form-control"
											onChange={(e) => setModalExpense({ ...modalExpense, 'note': e.target.value })} />
									</div>

								</div>
							</form>
						</Modal.Body>

						<Modal.Footer>
							<div className="w-100 d-flex justify-content-between gap-2">
								<button type="button" className="btn btn-outline-warning w-100"
									onClick={() => toggleModalExpense(false)}>
									{t('cancel')}
								</button>
								<button className="btn btn-primary w-100" onClick={(e) => createExpense(e)}>
									{t('confirm')}
								</button>
							</div>
						</Modal.Footer>
					</>
				}
			</Modal>

			<DeleteModal
				showNote={true}
				setNote={setModalDelete}
				modalDelete={modalDelete}
				setModalDelete={(bool) => toggleModalDelete(bool)}
				deleteItem={deleteExpense}
			/>

			<Modal show={modalExpenseCreate} animation={false}
				centered dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalExpenseCreate(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdateExpense(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name" value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('type')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'minus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'minus' })}>
											{t('expense')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}
											style={{ 'backgroundColor': selectedItem.transaction_type === 'plus' ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'transaction_type': 'plus' })}>
											{t('income')}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('operation_account')}</label>
							<Select
								isClearable
								options={accounts}
								value={accounts.find(option => option.id === selectedItem.account_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'account_id': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('report_account')}</label>
							<Select
								isClearable
								options={counterparties}
								value={counterparties.find(option => option.id === selectedItem.counterparty)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'counterparty': option ? option.id : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalExpenseCreate(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			{/* EXPENSE MODAL PAYMENT */}
			<Modal show={modalDebtors} animation={false} centered size="xl"
				dialogClassName="expense-modal" onHide={() => toggleModalDebtors(false)}>
				<Modal.Header closeButton className="d-flex gap-2">
					<Modal.Title className="d-flex align-items-center gap-2">
						{t('debtors')}
					</Modal.Title>
					<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
						<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
							{t('filter')}
						</Dropdown.Toggle>

						<Dropdown.Menu className="dropdown-filter">
							<div className="row">
								<div className="form-group col-md-6">
									<label>{t('cashier')}</label>
									<Select
										options={cashiers}
										value={cashiers.find(option => option.login === filterData?.cashier_login) || ''}
										// value={filterData.cashiers}
										onChange={(option) => setFilterData({ ...filterData, cashier_login: option?.login })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.login}
										isClearable
									// isMulti
									/>
								</div>
								<div className="form-group col-md-6">
									<label>{t('clients')}</label>
									<Select
										options={clients}
										value={clients.find(option => option.id === filterData.client_id) || ''}
										onChange={(option) => setFilterData({ ...filterData, 'client_id': option?.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
										isClearable
									/>
								</div>
							</div>
							<div className="row">
								<div className="form-group col-md-4">
									<label>{t('period')}</label>
									<Select
										options={chequeDates}
										// value={chequeDates.find(option => option.id === filterData.status) || ''}
										onChange={(option) => selectChequeDates(option)}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>

								<div className="form-group col-md-4">
									<label className="invisible">{t('period')}</label>
									<div className="calendar-input">
										<DatePicker
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={filterData.start_date ? new Date(filterData.start_date) : ''}
											onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
								<div className="form-group col-md-4">
									<label className="invisible">.</label>
									<div className="calendar-input">
										<DatePicker
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={filterData.end_date ? new Date(filterData.end_date) : ''}
											onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-md-12">
									<div className="d-flex justify-content-end gap-2">
										<button className="btn btn-secondary"
											onClick={() => setDropdownIsOpen(false)}>
											{t('cancel')}
										</button>
										<button className="btn btn-primary"
											onClick={() => getDebtors()}>
											{t('apply')}
										</button>
									</div>
								</div>
							</div>
						</Dropdown.Menu>
					</Dropdown>
				</Modal.Header>

				<Modal.Body>


					<table className="table table-bordered">
						<thead>
							<tr>
								<th style={{ minWidth: '33px' }}>#</th>
								<th style={{ width: '20%' }} className="td-ellipsis">{t('name')}</th>
								<th style={{ minWidth: '120px' }} className="td-ellipsis">{t('phone')}</th>
								<th style={{ width: '20%' }} className="td-ellipsis">{t('cashier')}</th>
								{/* <th className="text-end">{t('total_amount_debt')}</th> */}
								<th style={{ minWidth: '150px' }} className="text-center">{t('remaining_before_payment')}</th>
								<th style={{ minWidth: '155px' }} className="text-center">{t('debt_payment_date')}</th>
								<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('paid')}</th>
								<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('not_paid')}</th>
								<th style={{ minWidth: '100px' }} className="text-end td-ellipsis">{t('amount_of_debt')}</th>
							</tr>
						</thead>
						<tbody>
							{debtors.map((item, index) => (
								<tr key={index}>
									<td>{index + 1}</td>
									<td className="td-ellipsis">
										<CustomTooltip text={item.name}>
											{item.name}
										</CustomTooltip>
									</td>
									<td>{regexPhoneNumber(item.phone)}</td>
									<td>{item.cashier_name}</td>
									{/* <td className="text-end">{formatMoney(item.balance)}</td> */}
									<td className="text-center">{Math.abs(getDifference(item.debt_date))}</td>
									<td className={`text-center ${getDifference(item.debt_date) < 0 ? 'bg-danger text-white' : ''}`}>
										{formatDate(item.debt_date)}
									</td>
									<td className="text-end">{formatMoney(item.paid)}</td>
									<td className="text-end">{formatMoney(item.amount - item.paid)}</td>
									<td className="text-end">{formatMoney(item.amount)}</td>
								</tr>
							))
							}
						</tbody>
					</table>
				</Modal.Body>
			</Modal>

			<Modal show={modalClients} animation={false} centered size="xl" dialogClassName="expense-modal" onHide={() => toggleModalClients(false)}>
				<Modal.Body>
					{selectedClient.client_id ?
						<ClientsHistory modal={true} clientId={selectedClient.client_id} />
						:
						<Clients modal={true} setModal={(bool) => toggleModalClients(bool)} selectClient={(item) => setSelectedClient({ ...item })} />
					}
				</Modal.Body>
			</Modal>

			<Directory showModal={modalDirectory} setShowModal={setModalDirectory} />

			<Modal show={xReport.show} animation={false}
				centered dialogClassName="x-report-modal-width" size="xl"
				onHide={() => setXReport({ ...xReport, show: false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('information')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<XReport xReport={xReport} toggleModalExpense={toggleModalExpense} />
				</Modal.Body>
			</Modal>

			<Modal show={modalRolls} animation={false} size="xl" centered
				onHide={() => setModalRolls(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('rolls')}</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ height: '500px', overflow: 'auto' }}>
					<div className="mb-2">
						<label>{t('search')}</label>
						<input autoFocus type="text" className="form-control" value={search}
							onChange={(e) => setSearch(e.target.value)} />
					</div>

					<div className="d-flex">
						<div className="d-flex flex-column gap-1" style={{ width: '300px' }}>
							{getCategoriesList()?.map((item, index) => (
								<div className={`cursor ${item.id === selectedCategory.id ? 'text-primary' : ''}`}
									onClick={() => setSelectedCategory(item)} key={index}>
									{item.name}
								</div>
							))}
						</div>
						<div className="w-100">

							<div>
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ width: '25%' }}>{t('name2')}</th>
											<th style={{ width: '15%' }}>{t('warehouse')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('ton')}</th>
											<th style={{ width: '10%' }} className="text-end">{t('metr')}</th>
											<th style={{ width: '15%' }} className="text-center">{t('date')}</th>
											<th style={{ width: '20%' }} className="text-center"></th>
										</tr>
									</thead>
									<tbody>
										{selectedCategory?.products?.map((item, index) => (
											<tr key={index}>
												<td>{item.name}</td>
												<td>{item.wms_name}</td>
												<td className="text-end">{item.original_quantity}</td>
												<td className="text-end">{item.balance}</td>
												<td className="text-center">{formatDate(item.created_at, "dd.MM.yyyy HH:mm")}</td>
												<td className="text-center p-0">
													<button className="btn btn-primary p-0 w-100 br-0" style={{ height: '30px' }} onClick={() => toggleOpenRollModalConfirm(true, item)}>
														{t('open2')}
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>

			<Modal show={openRollModalConfirm.show} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => toggleOpenRollModalConfirm(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('roll')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('are_you_sure_you_want_open_roll')}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => toggleOpenRollModalConfirm(false)}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100"
							onClick={() => openRoll(openRollModalConfirm.item)}>
							{t('confirm')}
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default Header
